'use client';

import classNames from 'classnames';
import useModals from './useModals';
import CloseButton from '@/shared/components/Buttons/CloseButton/CloseButton';
import { ComponentProps } from 'react';

interface ModalCloseLinkProps {
  className?: string;
  closeAction?: 'url' | 'state';
  modalName: string;
  iconVariant?: ComponentProps<typeof CloseButton>['iconVariant'];
}

const ModalCloseLink = ({
  className,
  modalName,
  closeAction = 'url',
  iconVariant = 'close',
}: ModalCloseLinkProps) => {
  const { onClose, onCloseState } = useModals({ modalName });
  const onCloseHandler = closeAction === 'url' ? onClose : onCloseState;
  return (
    <CloseButton
      onClose={onCloseHandler}
      tabIndex={-1}
      className={classNames('flex', className)}
      iconVariant={iconVariant}
    />
  );
};

export default ModalCloseLink;
